import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-wrapper-cabinet',
    templateUrl: './wrapper.component.html',
    styleUrl: './wrapper.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class WrapperCabinetComponent {

}
